var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33 33",
    style: {
      enableBackground: "new 0 0 33 33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8d99a3",
    d: "M16.5,33C7.402,33,0,25.598,0,16.5S7.402,0,16.5,0S33,7.402,33,16.5S25.598,33,16.5,33z M16.5,1C7.953,1,1,7.953,1,16.5 S7.953,32,16.5,32S32,25.047,32,16.5S25.047,1,16.5,1z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8d99a3",
    cx: 11.702,
    cy: 11.93,
    r: 2.125
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8d99a3",
    cx: 21.827,
    cy: 11.93,
    r: 2.125
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d99a3",
    d: "M10.326,23.918c-0.09,0-0.18-0.024-0.262-0.074c-0.235-0.146-0.308-0.453-0.163-0.688c1.429-2.314,3.905-3.696,6.623-3.696 c2.679,0,5.136,1.352,6.572,3.615c0.148,0.233,0.079,0.542-0.154,0.689c-0.234,0.147-0.542,0.08-0.69-0.154 c-1.251-1.973-3.393-3.15-5.727-3.15c-2.368,0-4.526,1.204-5.772,3.222C10.658,23.834,10.494,23.918,10.326,23.918z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.150f793f90c3517b5c8bbd3ceaa6218f.svg";
export { ForwardRef as ReactComponent };